import { toMoneyWithMaximumTwoDecimalDigits } from "utils/currency";
import { CheckoutSummaryPill } from "components/UI/atoms";
import "./index.scss";
import { useCheckoutContext } from "context/checkout-context";

export const CheckoutSummaryTable = () => {
  const {
    checkoutData: { cards }
  } = useCheckoutContext();

  return (
    <table className="checkout-summary-table">
      <thead className="table-header">
        <tr className="table-header-row">
          <th className="table-header-cell">Item</th>
          <th className="table-header-cell">Type</th>
          <th className="table-header-cell">Value</th>
          <th className="table-header-cell">Price</th>
        </tr>
      </thead>

      <tbody>
        {cards.map((item) => (
          <tr
            className="table-row-cell"
            key={item.id}
            data-testid="table-summary-row"
          >
            <td className="table-cell">{item.name}</td>
            <td className="table-cell type-cell">
              {item.type?.map((itemType) => (
                <CheckoutSummaryPill key={itemType} text={itemType} />
              ))}
            </td>
            <td className="table-cell">
              {toMoneyWithMaximumTwoDecimalDigits(item.value)}
            </td>
            <td className="table-cell">
              {toMoneyWithMaximumTwoDecimalDigits(item.price)}
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};
